import { useContext, useMemo } from 'react';

import { LocalStorageContext } from '../providers/LocalStorageContext';

/*
 *  Usage:
 *    const [value, setValue, removeValue] = useLocalStorage<T>(key: string);
 *
 *  Example:
 *    const [profile, setProfile, removeProfile] = useLocalStorage<Profile>("user");
 */

export const useLocalStorage = <T>(
  key: string,
): [T | null | undefined, (value: T | null) => void, () => void] => {
  const ctx = useContext(LocalStorageContext);
  if (!ctx) {
    throw new Error('Please configure LocalStorageContext before using "useLocalStorage()"');
  }
  const { setValue, removeValue } = ctx;
  return [
    ctx.state.data[key] as T,
    useMemo(() => setValue(key), [key, setValue]),
    useMemo(() => removeValue(key), [key, removeValue]),
  ];
};
